import { createContext, useContext } from 'react';

/** Ends the staff sign-in; null when there is none to end (no application on this stage, or nobody signed in). */
export type StaffSignOut = (() => Promise<void>) | null;

/** Kept apart from the provider so code outside it, such as the console's Logout, need not load the identity SDK. */
export const StaffSignOutContext = createContext<StaffSignOut>(null);

/**
 * Signing out of the identity provider too is what makes the next sign-in mint fresh tokens: the SDK
 * otherwise keeps the organization token, and with it the permissions it was minted with, for its lifetime.
 */
export const useStaffSignOut = (): StaffSignOut => useContext(StaffSignOutContext);
